const GET_DATA_FROM_API = 'GET_DATA_FROM_API';
const GET_DETAILS_FROM_API = 'GET_DETAILS_FROM_API';
const ASYNC_FETCH = 'ASYNC_FETCH';
const ASYNC_FETCH_SUCCESS = 'ASYNC_FETCH_SUCCESS';
const GET_DATA_SUCCESS = 'GET_DATA_SUCCESS';
const GET_DETAILS_FROM_API_SUCCESS = 'GET_DETAILS_FROM_API_SUCCESS';
const GET_SLOTS_SDD = 'GET_SLOTS_SDD';
const GET_SLOTS_SDD_SUCCESS = 'GET_SLOTS_SDD_SUCCESS';
const ERR_OCCURED = 'ERR_OCCURED';
const GET_ENABLED_DEVICES = 'GET_ENABLED_DEVICES';
const GET_ENABLED_DEVICES_SUCCESS = 'GET_ENABLED_DEVICES_SUCCESS';
const FETCH_SMS_DEVICES_SUCCESS = 'FETCH_SMS_DEVICES_SUCCESS';
const GET_SEND_SMS = 'GET_SEND_SMS';
const GET_SEND_SMS_SUCCESS = 'GET_SEND_SMS_SUCCESS';
const CODE_VALIDATION = 'CODE_VALIDATION';
const POST_SHIPPING_OPTION = 'POST_SHIPPING_OPTION';
const POST_SHIPPING_OPTION_SUCCESS = 'POST_SHIPPING_OPTION_SUCCESS';
const DEFAULT_ERR_MSG = 'We are unable to process the request at this time. Please try after sometime';
const UPDATE_SHIPPING_ADDRESS = 'UPDATE_SHIPPING_ADDRESS';
const UPDATE_SHIPPING_ADDRESS_SUCCESS = 'UPDATE_SHIPPING_ADDRESS_SUCCESS';
const CODE_VALIDATION_SUCCESS = 'CODE_VALIDATION_SUCCESS';
const GET_ZIP_DETAILS_FROM_API = 'GET_ZIP_DETAILS_FROM_API';
const UPDATE_ISPU_STORE_INFO = 'UPDATE_ISPU_STORE_INFO';
const UPDATE_ADRESS_SUUCESS = 'UPDATE_ADRESS_SUUCESS';
const SET_ISPU_MODAL = 'SET_ISPU_MODAL';
const EMAIL_VALIDATION_SHIPPING_API = 'EMAIL_VALIDATION_SHIPPING_API';
const ISPU_OPTION = {
  shippingOptionId: 'ISPU',
  shippingCost: 0,
  active: true,
  shippingDescription: 'Availability dependant on store address',
  shippingDescriptionVDSUpgrade: 'Availability dependant on<br>store address',
  name: 'Free In-Store Pickup',
  shortDescription: 'Free in-store pickup',
  description: 'Check availability.',
};
const INVALID_ADDRESS = 'INVALID_ADDRESS';
const GET_SHIPPING_OPTION_HEADER = 'GET_SHIPPING_OPTION_HEADER';
const RESET_ISPU_MODAL = 'RESET_ISPU_MODAL';
const TOGGLE_WHWISPU_MODAL = 'TOGGLE_WHWISPU_MODAL';
const ACCOUNT_MAINTENENCE_SHIPPING_EMAIL_VERIFICATION = 'ACCOUNT_MAINTENENCE_SHIPPING_EMAIL_VERIFICATION';
const ACC_MAIN_EMAIL_VALIDATION = 'ACC_MAIN_EMAIL_VALIDATION';
const SHIPPING_FETCH_SMS_DEVICES_ERROR = 'SHIPPING_FETCH_SMS_DEVICES_ERROR';
const SEND_OTP_ON_EMAIL = 'SEND_OTP_ON_EMAIL';
// const VERIFY_OTP_OF_EMAIL = 'VERIFY_OTP_OF_EMAIL';
const SEND_OTP_RESPONSE = 'SEND_OTP_RESPONSE';
const VERIFY_OTP_RESPONSE = 'VERIFY_OTP_RESPONSE';
const VERIFY_EMAIL_OTP = 'VERIFY_EMAIL_OTP';
export const CONTINUE_CTA_STICKY_FOOTER = 'Continue';
export const PRICE_ZERO = '$0.00';
export const VCS = 'Verizon Company Store';
export const VAR = 'Verizon Authorized Retailer';
const SHIPPING_INVALID_CASE_ERROR = 'SHIPPING_INVALID_CASE_ERROR';
export const NEW_SHIPPING_ADDRESS = 'Enter a new shipping address';
export const SAME_5G_SERVICE_ADDRESS = 'Same as 5G service address';
export const SAME_5G_BILLING_ADDRESS = 'Same as 5G billing address';
export const SAME_LTE_BILLING_ADDRESS = 'Same as LTE Home Internet billing address';
export const SAME_LTE_SERVICE_ADDRESS = 'Same as LTE Home Internet service address';
export const SAME_VHI_LITE_SERVICE_ADDRESS = 'Same as Verizon Home Internet Lite service address';
export const SAME_VHI_LITE_BILLING_ADDRESS = 'Same as Verizon Home Internet Lite billing address';
export const SAME_LTE_LQ_ADDRESS = 'Same as LTE Home Internet service address';
export const SAME_5G_LQ_ADDRESS = 'Same as 5G Home Internet service address';
export const CEF_SHIPPING_INFO_ERROR = 'CEF_SHIPPING_INFO_ERROR';
export const DEFAULT_ERROR_MESSAGE = 'Looks like something went wrong. Please try again later.';
export const MISSING_APARTMENT_UNIT_CODE = '360402';
export const INVALID_APARTMENT_UNIT_CODE = '360401';
export const MISSING_APARTMENT_UNIT_NAME = 'MISSING_APARTMENT_UNIT_NUMBER_FROM_ADDRESS';
export {
  GET_DATA_FROM_API,
  GET_DETAILS_FROM_API,
  ASYNC_FETCH,
  ASYNC_FETCH_SUCCESS,
  GET_DATA_SUCCESS,
  GET_DETAILS_FROM_API_SUCCESS,
  ERR_OCCURED,
  GET_SLOTS_SDD,
  GET_SLOTS_SDD_SUCCESS,
  GET_ENABLED_DEVICES,
  GET_ENABLED_DEVICES_SUCCESS,
  FETCH_SMS_DEVICES_SUCCESS,
  GET_SEND_SMS,
  GET_SEND_SMS_SUCCESS,
  CODE_VALIDATION,
  POST_SHIPPING_OPTION,
  POST_SHIPPING_OPTION_SUCCESS,
  CODE_VALIDATION_SUCCESS,
  DEFAULT_ERR_MSG,
  ISPU_OPTION,
  UPDATE_SHIPPING_ADDRESS,
  UPDATE_SHIPPING_ADDRESS_SUCCESS,
  GET_ZIP_DETAILS_FROM_API,
  UPDATE_ISPU_STORE_INFO,
  UPDATE_ADRESS_SUUCESS,
  INVALID_ADDRESS,
  GET_SHIPPING_OPTION_HEADER,
  SET_ISPU_MODAL,
  RESET_ISPU_MODAL,
  SHIPPING_FETCH_SMS_DEVICES_ERROR,
  SHIPPING_INVALID_CASE_ERROR,
  EMAIL_VALIDATION_SHIPPING_API,
  ACCOUNT_MAINTENENCE_SHIPPING_EMAIL_VERIFICATION,
  ACC_MAIN_EMAIL_VALIDATION,
  TOGGLE_WHWISPU_MODAL,
  SEND_OTP_ON_EMAIL,
  // VERIFY_OTP_OF_EMAIL,
  SEND_OTP_RESPONSE,
  VERIFY_OTP_RESPONSE,
  VERIFY_EMAIL_OTP,
};
export const UPDATE_SHIPPING_ADDRESS_ERROR = "UPDATE_SHIPPING_ADDRESS_ERROR";